import validate from "/usr/src/app/content/n3-treatments-f80220fd-37c5-4796-87e4-e05a219275ac/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-treatments-f80220fd-37c5-4796-87e4-e05a219275ac/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}